import { Router } from './navigation/router';
import React from 'react';

function App() {
  return (
    <Router />
  );
}

export default App;

//git pull origin dev
